var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.1875 20C2.82812 20 0.09375 17.2656 0.09375 13.8672C0.09375 12.2266 0.71875 10.6641 1.85156 9.53125L10.0938 1.28906C10.9531 0.46875 12.1641 0 13.3359 0C16.2656 0 17.9062 2.38281 17.9062 4.53125C17.9062 5.74219 17.3984 6.91406 16.5391 7.77344L9 15.3125C8.41406 15.8984 7.63281 16.1719 6.89062 16.1719C4.50781 16.1719 3.88281 14.0625 3.88281 13.2031C3.88281 12.4609 4.19531 11.6797 4.78125 11.0938L10.3281 5.54688C10.5625 5.3125 10.8359 5.23438 11.1094 5.23438C11.6953 5.23438 12.2031 5.70312 12.2031 6.32812C12.2031 6.60156 12.0859 6.875 11.8906 7.10938L6.30469 12.6562C6.14844 12.8125 6.07031 13.0078 6.07031 13.2031C6.07031 13.6719 6.46094 14.0234 6.89062 14.0234C7.08594 14.0234 7.28125 13.9453 7.4375 13.7891L15.0156 6.21094C15.4453 5.74219 15.6797 5.15625 15.6797 4.53125C15.6797 3.4375 14.8594 2.1875 13.3359 2.1875C12.7109 2.1875 12.0859 2.42188 11.6562 2.85156L3.41406 11.0938C2.67188 11.8359 2.28125 12.8125 2.28125 13.8672C2.28125 15.7422 3.64844 17.7734 6.1875 17.7734C7.24219 17.7734 8.25781 17.4219 9 16.6797L15.2109 10.4297C15.4453 10.2344 15.7188 10.1172 15.9922 10.1172C16.5781 10.1172 17.0859 10.5859 17.0859 11.2109C17.0859 11.4844 16.9688 11.7578 16.7734 11.9922L10.5234 18.2031C9.39062 19.375 7.82812 20 6.1875 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFileUpload);
export default __webpack_public_path__ + "static/media/chatFileUpload.98b0c66dbaa604c5bacb6cdda509cddb.svg";
export { ForwardRef as ReactComponent };